/**
 * @author Akash Mishra <akashmishra@eurofins.com>
 */
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { OrderMessages } from 'src/app/shared/error-messages';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { OrdersService } from '../Service/order.service';

@Component({
    selector: 'app-order-close-dialog',
    templateUrl: './order-close-dialog.component.html',
    standalone: false
})
export class OrderCloseDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<OrderCloseDialogComponent>,
              private broadcastService: BroadcastService, private orderService: OrdersService,
              private router: Router, private route: ActivatedRoute) { }

  @Output() toggleOrderSidenav = new EventEmitter<void>();
  ngOnInit(): void {
    // can perform any logical implemention here if required
  }

  close() {
    this.broadcastService.broadcast(OrderMessages.CLOSE_ORDER, { close: true });
    sessionStorage.removeItem('OrderAccountCode');
    sessionStorage.removeItem('OrderAccountName');
    sessionStorage.removeItem('OrderAccountState');
    sessionStorage.removeItem('OrderBuCode');
    this.orderService.clear();
    this.router.navigate(['./order'], { relativeTo: this.route });
    this.dialogRef.close();
  }
}
